<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="horario-layout" titulo="Layout Horario" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>

        <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">
          <a id="catalogos"
            (click)="ctrl.cargarCatalogo('turnos', 'turnos'); ctrl.cargarCatalogo('modalidades', 'modalidad'); "></a>
            <!-- <a id="enviarModalidades" (click)="ctrl.modalidades = [];cargarModalidades(ctrl.modalidades)"></a> -->

           
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <label class="label">Nombre:</label>
                <!-- <div class="control is-expanded  has-icon has-icon-left">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.controls.personas_metadatos.get('nombre').hasError('required') }" placeholder="Nombre" formControlName="nombre">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.controls.personas_metadatos.get('nombre').hasError('required') ">
                        <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.controls.personas_metadatos.get('nombre').hasError('required') ">Este campo es requerido.</span>
                </div> -->

                <div class="control is-expanded  has-icon has-icon-left">
                  <input class="input" type="text" placeholder="Nombre" formControlName="nombre">
                  <!-- <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es
                    requerido.</span> -->
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="field">
                <div class="b-checkbox is-info" style="margin-top: 2.5em;">
                  <input id="predeterminado" class="styled" type="checkbox" style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;"
                    [checked]="ctrl.dato.get('predeterminado').value == '1' ? true : false"
                    (change)="ctrl.dato.get('predeterminado').patchValue(ctrl.dato.get('predeterminado').value == '1' ? '0' : '1')">
                  <!-- 
                    [checked]="ctrl.dato.controls.personas_metadatos.get('acta_nacimiento').value == '1' ? true : false"
                    (change)="ctrl.dato.controls.personas_metadatos.get('acta_nacimiento').patchValue(ctrl.dato.controls.personas_metadatos.get('acta_nacimiento').value == '1' ? '0' : '1')"
                     -->
                  <label for="predeterminado">
                    Predeterminado
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label">Modalidad:</label>
            <div class="control has-icons-left has-icons-right">
              <div class="select">
                <select class="select" formControlName="modalidades_id">
                  
                  <option value="">Seleccione</option>
                  <option *ngFor="let item of modalidades" value="{{item.id}}">{{item.nombre}} </option>
                </select>
              </div>
              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('modalidades_id').hasError('required') ">
                <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('modalidades_id').hasError('required') ">Este campo es
                requerido.</span>
            </div>
          </div>

          <div class="field">
            <label class="label">Turno:</label>
            <div class="control has-icons-left has-icons-right">
              <div class="select">
                <select class="select" formControlName="turnos_id">
                  <option value="">Seleccione</option>
                  <option *ngFor="let item of ctrl.turnos" value="{{item.id}}">{{item.nombre}} </option>
                </select>
              </div>
              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('turnos_id').hasError('required') ">
                <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('turnos_id').hasError('required') ">Este campo es
                requerido.</span>
            </div>
          </div>

          <div class="field">
            <label class="label">Duración de la clase:</label>
            <p class="control has-icons-left has-icons-right">
              <input class="input" type="number" min="0"
                [ngClass]="{'is-danger': ctrl.dato.get('duracion_clase').hasError('required') }"
                placeholder="Duración de la clase" formControlName="duracion_clase">
              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('duracion_clase').hasError('required') ">
                <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('duracion_clase').hasError('required') ">Este campo es
                requerido.</span>
            </p>
          </div>

          <div class="field">
            <label class="label">Hora de inicio:</label>
            <p class="control has-icons-left has-icons-right">
              <input class="input" type="time"
                [ngClass]="{'is-danger': ctrl.dato.get('hora_inicio').hasError('required') }"
                placeholder="Hora de inicio" formControlName="hora_inicio">
              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('hora_inicio').hasError('required') ">
                <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('hora_inicio').hasError('required') ">Este campo es
                requerido.</span>
            </p>
          </div>

        </section>
      </form>
    </div>
  </div>
</div>